import { FC } from 'react';
import { UserProjectStatus } from '@teachur/http-client';

interface ProjectStatusMessageProps {
  status?: UserProjectStatus;
}

const PROJECT_STATUS_MESSAGE_CONFIG = {
  [UserProjectStatus.Pending]: {
    backgroundColorClassName: 'bg-(--warning-W100)',
    textColorClassName: 'text-(--warning-W700)',
    message:
      'Your project has been submitted successfully. You will be notified when an Instructor has claimed it (usually within 48 hours), and you can expect to receive the review within 7 days.',
  },
  [UserProjectStatus.InReview]: {
    backgroundColorClassName: 'bg-(--warning-W100)',
    textColorClassName: 'text-(--warning-W700)',
    message: 'Your project has been claimed. You can expect the completed review within 7 days.',
  },
  [UserProjectStatus.NotYet]: {
    backgroundColorClassName: 'bg-(--danger-D200)',
    textColorClassName: 'text-(--danger-D700)',
    message:
      'Your project has been reviewed but is not yet approved. Please carefully review and incorporate the feedback, then submit your revised project.',
  },
  [UserProjectStatus.Approved]: {
    backgroundColorClassName: 'bg-(--success-S200)',
    textColorClassName: 'text-(--success-S700)',
    message:
      "Congratulations! Your project was approved. You've unlocked the final step: The Course Hearing.",
  },
} satisfies Partial<
  Record<
    UserProjectStatus,
    {
      backgroundColorClassName: string;
      textColorClassName: string;
      message: string;
    }
  >
>;

export const ProjectStatusMessage: FC<ProjectStatusMessageProps> = ({ status }) => {
  if (!status) return null;

  const statusConfig = PROJECT_STATUS_MESSAGE_CONFIG[status];

  if (!statusConfig) return null;

  return (
    <div className={`flex w-full rounded-xl p-4 ${statusConfig.backgroundColorClassName}`}>
      <p
        className={`m-0! [font-size:var(--fs-l5)]! lg:[font-size:var(--fs-p3)]! font-medium ${statusConfig.textColorClassName}`}
      >
        {statusConfig.message}
      </p>
    </div>
  );
};
